import { LocalAudioTrack } from 'twilio-video';
import { useCallback } from 'react';
import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useLocalAudioToggle() {
  const { room: {localParticipant},localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);

  const toggleAudioEnabled = useCallback((props: any) => {

    if (audioTrack) {
      if(audioTrack.isEnabled){
        audioTrack.disable();
        // if(props.muteUnmuteParticipant){
        //   props.muteUnmuteParticipant(true);
        // }
      }else {
        
        if(localParticipant){
          localParticipant.publishTrack(audioTrack);
        }
        else if(props.room && props.room.activeRoom && props.room.activeRoom.localParticipant){
          props.room.activeRoom.localParticipant.publishTrack(audioTrack);
        }
        audioTrack.enable();
        let callId = props.patient && props.patient.activeCall && props.patient.activeCall.callId

        if(props.patient && props.patient.activeCall && props.patient.activeCall.isMute && props.patient.activeCall.isMute == "true"){
          if(props.muteParticipant){
            

            props.muteParticipant(false);
          }
        }
        
      }
    }
  }, [audioTrack]);
  

  return [isEnabled, toggleAudioEnabled] as const;
}
